'use client'

import { ChevronRightIcon, ChevronLeftIcon } from 'primitives/icons'

import { CarouselControlButton } from './button'
import { useCarouselContext } from './context'

export function Controls() {
  const { prevButtonProps, nextButtonProps } = useCarouselContext()

  return (
    <>
      <div className="flex gap-2">
        <CarouselControlButton
          {...prevButtonProps}
          key="previous-button"
          name="prev"
          aria-label="Previous slide"
        >
          <ChevronLeftIcon />
        </CarouselControlButton>
        <CarouselControlButton
          key="next-button"
          name="next"
          aria-label="Next slide"
          {...nextButtonProps}
        >
          <ChevronRightIcon />
        </CarouselControlButton>
      </div>
    </>
  )
}

Controls.displayName = 'Carousel.Controls'
